'use client'
import Footer from "@/components/common/Footer/Footer";
import Header from "@/components/common/Header/Student/Header";
import InstuctorHeader from "@/components/common/Header/Teacher/TeacherHeader";

export default function HomeLayout({ children }) {
  return (
    <div className="site">
      <InstuctorHeader />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
